module.exports = __webpack_public_path__ + "img/logo-pc.c7c58a4.svg";